import './App.css';
import { useState } from 'react';

function App() {
  const [page, setPage] = useState('accueil');
  const [favoris, setFavoris] = useState([]);

  // Exemple de données de sourates
  const sourates = [
    { id: 1, nom: 'Al-Fatiha', versets: 7 },
    { id: 2, nom: 'Al-Baqarah', versets: 286 },
    { id: 3, nom: "Aal-'Imran", versets: 200 },
    // Ajoute plus de sourates ici
  ];

  const ajouterFavori = (sourate) => {
    if (!favoris.find(f => f.id === sourate.id)) {
      setFavoris([...favoris, sourate]);
      alert(`✅ ${sourate.nom} ajouté aux favoris !`);
    } else {
      alert(`📖 ${sourate.nom} est déjà dans vos favoris`);
    }
  };

  if (page === 'lecture') {
    return (
      <div className="App">
        <header className="App-header">
          <h1>📖 Lecture du Coran</h1>
          <div style={{ maxHeight: '400px', overflowY: 'scroll', margin: '20px' }}>
            {sourates.map(sourate => (
              <div key={sourate.id} style={{
                background: '#f0f0f0',
                margin: '10px',
                padding: '15px',
                borderRadius: '8px',
                color: '#333',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center'
              }}>
                <span>
                  <strong>{sourate.nom}</strong> ({sourate.versets} versets)
                </span>
                <button 
                  onClick={() => ajouterFavori(sourate)}
                  style={{
                    backgroundColor: '#4CAF50',
                    color: 'white',
                    border: 'none',
                    borderRadius: '5px',
                    padding: '8px 15px',
                    cursor: 'pointer'
                  }}
                >
                  ☆ Ajouter aux favoris
                </button>
              </div>
            ))}
          </div>
          <button onClick={() => setPage('accueil')}>← Retour</button>
        </header>
      </div>
    );
  }

  if (page === 'favoris') {
    return (
      <div className="App">
        <header className="App-header">
          <h1>⭐ Mes Favoris</h1>
          {favoris.length === 0 ? (
            <p>Vous n'avez pas encore de favoris</p>
          ) : (
            <div style={{ maxHeight: '400px', overflowY: 'scroll', margin: '20px' }}>
              {favoris.map(sourate => (
                <div key={sourate.id} style={{
                  background: '#f0f0f0',
                  margin: '10px',
                  padding: '15px',
                  borderRadius: '8px',
                  color: '#333'
                }}>
                  <strong>{sourate.nom}</strong> ({sourate.versets} versets)
                </div>
              ))}
            </div>
          )}
          <button onClick={() => setPage('accueil')}>← Retour</button>
        </header>
      </div>
    );
  }

  // Page d'accueil
  return (
    <div className="App">
      <header className="App-header">
        <h1>Bienvenue sur MyQuran</h1>
        <p>Votre application de lecture du Coran</p>
        <div style={{ marginTop: '30px' }}>
          <button 
            onClick={() => setPage('lecture')}
            style={{
              margin: '10px',
              padding: '15px 30px',
              fontSize: '18px',
              backgroundColor: '#4CAF50',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              cursor: 'pointer'
            }}
          >
            📖 Lire le Coran
          </button>
          <button 
            onClick={() => setPage('favoris')}
            style={{
              margin: '10px',
              padding: '15px 30px',
              fontSize: '18px',
              backgroundColor: '#FF9800',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              cursor: 'pointer'
            }}
          >
            ⭐ Mes favoris
          </button>
        </div>
      </header>
    </div>
  );
}

export default App;